import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";

const VARIANTS = [
  { id: "orizzontale", label: "Orizzontale", text: "Uso principale: sito, documenti, email.", src: "/brand/iosegnalo-logo-orizzontale.svg", bg: "bg-white", span: "md:col-span-2" },
  { id: "verticale", label: "Verticale", text: "Social, gadget, insegne.", src: "/brand/iosegnalo-logo-verticale.svg", bg: "bg-white", span: "" },
  { id: "negativo", label: "Negativo", text: "Per sfondi scuri.", src: "/brand/iosegnalo-logo-orizzontale-negativo.svg", bg: "bg-[#0D3061]", span: "md:col-span-2" },
  { id: "simbolo", label: "Simbolo", text: "Favicon, avatar, icona app.", src: "/brand/iosegnalo-simbolo.svg", bg: "bg-white", span: "" },
];
const PALETTE = [["Blu notte", "#0D3061"], ["Giallo sole", "#F3C10A"], ["Inchiostro", "#12201A"], ["Carta", "#FBFBF8"]];

export default function Brand() {
  return (
    <main className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:py-16" data-testid="brand-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0F2D5E]">Identità visiva</p>
      <div className="mt-2 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl">Logo ufficiale</h1>
          <p className="mt-4 max-w-2xl text-[#495850]">Il segnaposto con la stretta di mano e la scritta iosegnalo.net formano un unico logo.</p>
        </div>
        <Button asChild className="h-12 rounded-full bg-[#F4C20D] px-6 text-[#0F2D5E] hover:bg-[#E0B000]" data-testid="download-logo-kit-btn">
          <a href="/iosegnalo-logo-ufficiale.zip" download><Download className="mr-2 h-4 w-4" /> Scarica kit logo (SVG + PNG)</a>
        </Button>
      </div>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {VARIANTS.map((v, i) => (
          <article key={v.id} className={`rise overflow-hidden rounded-3xl border border-[#E2E5DC] bg-white ${v.span}`} style={{ animationDelay: `${i * 0.08}s` }} data-testid={`logo-variant-${v.id}`}>
            <div className={`flex h-56 items-center justify-center p-8 sm:h-64 ${v.bg}`}>
              <img src={v.src} alt={`iosegnalo.net ${v.label}`} className="max-h-full max-w-full object-contain" />
            </div>
            <div className="border-t border-[#E2E5DC] p-4">
              <h3 className="font-bold">{v.label}</h3>
              <p className="text-sm text-[#495850]">{v.text}</p>
            </div>
          </article>
        ))}
      </div>
      <h2 className="mt-14 text-2xl font-bold">Palette</h2>
      <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {PALETTE.map(([n, h]) => (
          <div key={h} className="overflow-hidden rounded-2xl border border-[#E2E5DC] bg-white">
            <div className="h-20" style={{ background: h }} />
            <div className="p-3 text-sm"><p className="font-semibold">{n}</p><p className="font-mono text-xs text-[#75867E]">{h}</p></div>
          </div>
        ))}
      </div>
    </main>
  );
}
